<template>
    <ui-modal :title="title" :close="() => {}" :no-cancel="true">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-300 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-check text-white"></i>
            </div>
        </template>
        <p
            class="text-sm leading-5 text-gray-500"
            v-for="(paragraph, index) in paragraphs"
            :key="index"
            v-text="paragraph"
        ></p>
        <template #footer-primary>
            <ui-button-new success class="w-full" @click="close" v-text="button"></ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import UiProgressLine from "./UiProgressLine.vue";

export default {
    components: {UiProgressLine},
    props: {
        handle: Function,
        close: Function,
        title: {
            type: String,
            default: 'Please wait...'
        },
        progress: 0,
        useProgress: {
            type: Boolean,
            default: false,
        },
        paragraphs: {
            type: Array,
            default: () => [
                'Success',
            ],
        },
        button: {
            type: String,
            default: 'OK'
        },
    },
    data () {
        return {
        }
    },
}
</script>
